// extracted by mini-css-extract-plugin
export default {"btn-left-icon":"ButtonLeftIcon_btn-left-icon__a2t9+","icon-wrapper":"ButtonLeftIcon_icon-wrapper__hMDta","text-wrapper":"ButtonLeftIcon_text-wrapper__cRmaQ"};